import styled from 'styled-components';
import theme from '../../constants/theme';

export const ErrorSC = styled.div`
  font-weight: 700;
  font-size: 10px;
  color: ${theme.colors.error};
  padding-left: 16px;
`;
